module.exports = __webpack_public_path__ + "img/dongman.74d57638.png";